export const logoData = [
  {
    id: 1,
    logo: "../../assets/img/HTML5_logo.png",
    alt: "html5",
    name: "HTML 5",
  },
  {
    id: 2,
    logo: "../../assets/img/sass.png",
    alt: "sass",
    name: "Sass",
  },
  {
    id: 3,
    logo: "../../assets/img/bootstrap.png",
    alt: "bootstrap",
    name: "Bootstrap",
  },
  {
    id: 4,
    logo: "../../assets/img/tailwind_css.png",
    alt: "tailwind",
    name: "Tailwind CSS",
  },
  {
    id: 5,
    logo: "../../assets/img/javascript.webp",
    alt: "javascript",
    name: "JavaScript",
  },
  {
    id: 6,
    logo: "../../assets/img/react.webp",
    alt: "reactjs",
    name: "ReactJs",
  },
  {
    id: 7,
    logo: "../../assets/img/typescript.webp",
    alt: "typescript",
    name: "TypeScript",
  },
  {
    id: 8,
    logo: "../../assets/img/nextjs.png",
    alt: "nextjs",
    name: "NextJs",
  },
  {
    id: 9,
    logo: "../../assets/img/vitejs-logo.svg",
    alt: "vite",
    name: "Vite",
  },
  {
    id: 10,
    logo: "../../assets/img/wordpress.png",
    alt: "wordpress",
    name: "WordPress",
  },
  {
    id: 11,
    logo: "../../assets/img/elementor-icon.svg",
    alt: "elementor",
    name: "Elementor",
  },
  {
    id: 12,
    logo: "../../assets/img/aws.webp",
    alt: "aws",
    name: "AWS",
  },
];
